module.exports = __webpack_public_path__ + "img/en.c849ce13.png";